import { createFileRoute } from "@tanstack/react-router";
import { SEOPage } from "@/components/site/SEOPage";

export const Route = createFileRoute("/lgpd")({
  head: () => ({
    meta: [
      { title: "LGPD - P2 PRO | Proteção de Dados de Acordo com a Lei" },
      { name: "description", content: "Conheça como a P2 PRO cumpre a Lei Geral de Proteção de Dados Pessoais. Seu direito à privacidade e segurança de dados respeitado integralmente." },
    ],
  }),
  component: () => (
    <SEOPage
      category="Institucional"
      title="LGPD: LEI GERAL DE PROTEÇÃO DE DADOS NA P2 PRO"
      subtitle="Compromisso total com o tratamento ético e seguro das suas informações pessoais."
      introParagraphs={[
        "A Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018), mais conhecida como LGPD, veio para estabelecer um novo patamar de segurança jurídica e proteção de dados no Brasil. Na P2 PRO, recebemos esta legislação não apenas como uma obrigação, mas como uma oportunidade de reforçar nosso pacto de confiança com cada revendedor e cliente.",
        "Implementamos controles rigorosos de governança de dados em todos os nossos sistemas, garantindo que as informações coletadas sejam tratadas com a finalidade exclusiva de prestação de serviços técnicos de streaming e suporte administrativo.",
        "Nesta página, detalhamos como você pode exercer seus direitos garantidos pela lei e como nossa infraestrutura foi adaptada para garantir que o seu negócio de revenda esteja em total conformidade com as exigências da Autoridade Nacional de Proteção de Dados (ANPD)."
      ]}
      benefits={[
        {
          title: "Direito de Acesso",
          description: "Você pode solicitar a qualquer momento um relatório de quais dados possuímos em nosso banco de dados.",
        },
        {
          title: "Portabilidade de Dados",
          description: "Garantimos a facilidade de migração dos seus dados administrativos se assim desejar.",
        },
        {
          title: "Eliminação Garantida",
          description: "O direito ao esquecimento é respeitado: solicitou a exclusão, os dados são removidos definitivamente.",
        }
      ]}
      howItWorks={[
        { title: "Mapeamento", description: "Identificamos todo o ciclo de vida do dado dentro da P2 PRO, da coleta à exclusão." },
        { title: "Minimização", description: "Princípio de coletar apenas o estritamente necessário para que o painel funcione." },
        { title: "Segurança de Acesso", description: "Apenas pessoal técnico autorizado e sob contrato de sigilo tem acesso aos sistemas." },
        { title: "Atualização de Termos", description: "Monitoramento constante de mudanças na lei para ajustes imediatos em nossos processos." }
      ]}
      diferenciais={[
        { title: "DPO Dedicado", description: "Encarregado de Proteção de Dados pronto para atender solicitações oficiais." },
        { title: "Privacy by Design", description: "Novas funções do painel são desenvolvidas pensando na privacidade desde o rascunho." },
        { title: "Contratos Blindados", description: "Relação com nossos data centers que exige o mesmo nível de proteção de dados." }
      ]}
      faq={[
        {
          question: "A P2 PRO guarda dados dos meus clientes finais?",
          answer: "O painel armazena os logins que você cria. Recomendamos que você utilize apenas identificadores genéricos para manter o anonimato total dos seus usuários."
        },
        {
          question: "Como entro em contato sobre meus dados?",
          answer: "Temos um canal exclusivo para privacidade que pode ser acessado através do nosso suporte central via WhatsApp."
        },
        {
          question: "Meus dados saem do Brasil?",
          answer: "Utilizamos infraestrutura de nuvem global para garantir estabilidade, mas todos os provedores possuem contratos de proteção de dados compatíveis com a LGPD."
        }
      ]}
      breadcrumbs={[
        { label: "Institucional", href: "/" },
        { label: "LGPD", href: "/lgpd" }
      ]}
    />
  ),
});
